export default __webpack_public_path__ + "static/media/WS.9e6f4c15.svg";